"use client";

import * as React from "react";
import { QrCodeGenerator } from "@/providers/qrcode";
import { useInstance, useEffect } from "@/ui/hooks";
import { useRef } from "react";


export function QrCode(props: Readonly<{
  value: string;
  scale: number;
  border?: number;
  dotColor?: string;
  backgroundColor?: string;
  className?: string;
  onClick?: () => void;
}>) {
  const instance = useInstance();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const prevText = useRef<string | undefined>(undefined);

  useEffect([
    props.value,
    props.scale,
    props.border,
    props.dotColor,
    props.backgroundColor,
    canvasRef.current,
  ], () => {
    if (canvasRef.current && props.value && props.value !== prevText.current) {
      prevText.current = props.value;

      /* we want to wait because it's an expensive calculation */
      instance.drawingComplete().then(() => {
        const value = prevText.current;
        const canvas = canvasRef.current;

        if (instance.isMounted() && canvas && value) {
          const canvas = canvasRef.current;

          if (!canvas) {
            return;
          }

          const ecc = QrCodeGenerator.Ecc.MEDIUM;
          const qr = QrCodeGenerator.encodeText(value, ecc);

          const border = props.border ?? 2;
          const dotColor = props.dotColor ?? "#000000";
          const backgroundColor = props.backgroundColor ?? "#ffffff";

          const ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");

          if (!ctx) {
            throw new Error(`Coult not create canvas 2D rendering context`);
          }

          const size= (qr.size + border * 2) * props.scale;
          canvas.width = size;
          canvas.height = size;

          ctx.imageSmoothingEnabled = false;

          for (let y = -border; y < qr.size + border; y++) {
            for (let x = -border; x < qr.size + border; x++) {
              ctx.fillStyle = qr.getModule(x, y) ? dotColor : backgroundColor;
              ctx.fillRect((x + border) * props.scale, (y + border) * props.scale, props.scale, props.scale);
            }
          }
        }
      });
    }
  });

  return (
    <div
      className={props.className}
    >
      <canvas
        ref={canvasRef}
        className="canvas"
        onClick={props.onClick}
      />
    </div>
  );
};
